export default __webpack_public_path__ + "static/media/Shrimp_Society.a3ad95a0.svg";